"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PROPOSAL_PRICES = void 0;
exports.proposalFields = proposalFields;
exports.isProposalRoomCountValid = isProposalRoomCountValid;
exports.selectProposalProperty = selectProposalProperty;
exports.DEFAULT_PROPOSAL_PRICES = [
    { property: '3', label: 'דירת 3 חדרים', regularPrice: 1300, projectPrice: 1000 },
    { property: '4', label: 'דירת 4 חדרים', regularPrice: 1400, projectPrice: 1100 },
    { property: '5', label: 'דירת 5 חדרים', regularPrice: 1500, projectPrice: 1200 },
    { property: '6', label: 'דירת 6 חדרים', regularPrice: 1600, projectPrice: 1300 },
    { property: 'garden', label: 'דירת גן / פנטהאוז', regularPrice: 1700, projectPrice: 1400 },
];
function proposalFields(p) {
    return { clientName: p.clientName, phone: p.phone, address: p.address, dealId: p.dealId,
        property: p.property, rooms: p.rooms, regularPrice: p.regularPrice, price: p.price, internalComment: p.internalComment ?? '' };
}
function isProposalRoomCountValid(input) {
    return !['3', '4', '5', '6'].includes(input.property) || input.rooms === input.property;
}
function selectProposalProperty(input, property, prices) {
    const row = prices.find(p => p.property === property);
    return { ...input, property, rooms: property === 'garden' ? '' : property === 'custom' ? input.rooms : property,
        regularPrice: row?.regularPrice ?? null, price: row?.regularPrice ?? input.price };
}
